.pickerContainer {
  /* Hard code the height of the container so that tippy
   * is able to determine where to render */
  height: 435px;
}

.pickerContainer em-emoji-picker {
  /* The emoji picker is rendered within tippy, which
   * already has base styles for background, border and box shadow.
   * It is also a bit wider than the container by default. */
  width: 348px;
  background: none;
  border: none;
  box-shadow: none;

  /* Documentation at https: //github.com/missive/emoji-mart/blob/main/packages/emoji-mart-website/example-custom-styles.html
   * and combined with the <style> tag you can find in the DOM inspector (look
   * for [data-theme="dark"]) */
  --font-size: 16px;
  --rgb-background: var(--theme-rgb-primary-background);
  --rgb-color: var(--theme-rgb-primary-text);
  --color-border: var(--theme-primary-border);
  --rgb-input: var(--theme-rgb-input-background);
}
